import React from 'react';

const TenantFeaturePanel = ({ tenant, features = [], modules = [], onOverrideFeature, changingFeature }) => {
  const onToggle = async (feature) => {
    if (!tenant) return;
    await onOverrideFeature({
      tenantId: tenant.tenantId,
      featureKey: feature.featureKey,
      enabled: !feature.enabled,
    });
  };

  return (
    <section className="space-y-3 rounded-xl border border-slate-800 bg-slate-900/70 p-4">
      <div>
        <h3 className="text-sm font-semibold text-slate-100">Fitur</h3>
        <div className="mt-1 text-xs text-slate-400">Override per tenant (plan default tetap jadi baseline)</div>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full text-left text-xs text-slate-300">
          <thead>
            <tr className="text-slate-400">
              <th className="px-2 py-1">Feature Key</th>
              <th className="px-2 py-1">Status</th>
              <th className="px-2 py-1">Source</th>
              <th className="px-2 py-1">Aksi</th>
            </tr>
          </thead>
          <tbody>
            {features.map((feature) => (
              <tr key={feature.featureKey} className="border-t border-slate-800/70">
                <td className="px-2 py-1.5">{feature.featureKey}</td>
                <td className="px-2 py-1.5">{feature.enabled ? 'ENABLED' : 'DISABLED'}</td>
                <td className="px-2 py-1.5">{feature.source}</td>
                <td className="px-2 py-1.5">
                  <button
                    type="button"
                    disabled={changingFeature || !tenant}
                    onClick={() => onToggle(feature)}
                    className="rounded border border-slate-700 bg-slate-950 px-2 py-1 text-[11px] text-slate-200"
                  >
                    Toggle
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div>
        <h4 className="text-xs font-semibold uppercase tracking-[0.12em] text-slate-400">Module Access</h4>
        <div className="mt-2 flex flex-wrap gap-2">
          {modules.map((module) => (
            <span key={module} className="rounded-md border border-slate-700 bg-slate-950 px-2 py-1 text-[11px] text-slate-200">
              {module}
            </span>
          ))}
          {!modules.length ? <span className="text-xs text-slate-500">Belum ada module enabled.</span> : null}
        </div>
      </div>
    </section>
  );
};

export default TenantFeaturePanel;
